export * from './ShippingOptionSection'

export const minDefined = (amount1?: string, amount2?: string): number | undefined => {
  const m1 = Number(amount1)
  const m2 = Number(amount2)

  if (isNaN(m1) && isNaN(m2)) {
    return
  }
  if (isNaN(m2)) {
    return m1
  }
  if (isNaN(m1)) {
    return m2
  }

  return Math.min(m1, m2)
}
